export const CREATE_DRAFT_ORDERS = 'CREATE_DRAFT_ORDERS';
export const CREATE_DRAFT_ORDERS_SUCCESS = 'CREATE_DRAFT_ORDERS_SUCCESS';
export const CREATE_DRAFT_ORDERS_FAILURE = 'CREATE_DRAFT_ORDERS_FAILURE';

export const CREATE_AUTO_ORDERS = 'CREATE_AUTO_ORDERS';
export const CREATE_AUTO_ORDERS_SUCCESS = 'CREATE_ORDERS_AUTO_SUCCESS';
export const CREATE_AUTO_ORDERS_FAILURE = 'CREATE_ORDERS_AUTO_FAILURE';

export const CREATE_AUTO_TICKETS = 'CREATE_AUTO_TICKETS';
export const CREATE_AUTO_TICKETS_SUCCESS = 'CREATE_AUTO_TICKETS_SUCCESS';
export const CREATE_AUTO_TICKETS_FAILURE = 'CREATE_AUTO_TICKETS_FAILURE';

export const AUTO_PLANNING_ACTION = 'AUTO_PLANNING_ACTION';
export const AUTO_PLANNING_ACTION_SUCCESS = 'AUTO_PLANNING_ACTION_SUCCESS';
export const AUTO_PLANNING_ACTION_FAILURE = 'AUTO_PLANNING_ACTION_FAILURE';

export const DELETE_ORDERS = 'DELETE_ORDERS';
export const DELETE_ORDERS_SUCCESS = 'DELETE_ORDERS_SUCCESS';
export const DELETE_ORDERS_FAILURE = 'DELETE_ORDERS_FAILURE';

export const CREATE_SINGLE_ORDER_FAILURE = 'CREATE_SINGLE_ORDER_FAILURE';

export const SET_SELECTED_ROW_ACTION = 'SET_SELECTED_ROW_ACTION';

export const PUBLISH_TO_SAP_QUICK_ACTION = 'PUBLISH_TO_SAP_QUICK_ACTION';
export const PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS = 'PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS';
export const PUBLISH_TO_SAP_QUICK_ACTION_FAILURE = 'PUBLISH_TO_SAP_QUICK_ACTION_FAILURE';

export const RESET_DELETE_SUCCESS = 'RESET_DELETE_SUCCESS';
